const PSEvents = require('PSEvents');
const PSState = require('PSState');
const SlotUI = require('SlotUI');

cc.Class({
    extends: cc.Component,

    properties: {
        soundToggle: cc.Toggle,
        mainNode: cc.Node,
    },

    onLoad () {
        if (!this.soundToggle) {
            this.soundToggle = this.node.getComponent(cc.Toggle);
        }

        if (!this.mainNode) {
            this.mainNode = this.soundToggle.node;
        }
        this.mainNode.active = false;

        PSEvents.onEngineInitialized(() => {
            /**
             * Sound button
             */
             const soundConfig = SlotUI.getMenuElement(SlotUI.MenuElements.Audio);
             if (soundConfig && !soundConfig.enabled) {
                 this.mainNode.active = false;
             } else {
                this.mainNode.active = true;
             }

             this.soundToggle.isChecked = PSState.soundEnabled;
        });

        this.stateUpdated = (state) => { this.updateState(state); };
        PSEvents.subscribe(PSEvents.STATE_UPDATED, this.stateUpdated);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.STATE_UPDATED, this.stateUpdated);
    },

    updateState (state) {
        if (this.soundToggle.isChecked !== state.soundEnabled) {
            this.soundToggle.isChecked = state.soundEnabled;
        }
    },

    toggleSound () {
        PSState.set({ soundEnabled: this.soundToggle.isChecked });
    },

});
